import type { AutoIntegrationListItem, Enums } from "../types";

/**
 * This function is used to get the color of the auto integration list item's state.
 * @param state
 * @returns
 */
export function getIntegrationStateColor(
	state: AutoIntegrationListItem<unknown>["state"],
): Enums<"color"> {
	switch (state) {
		case "both":
			return "emerald";
		case "external":
			return "amber";
		case "internal":
			return "accent";
	}
}
